export interface EngineMetrics {
  fps: number;
  frameTimeMs: number;
  drawCalls: number;
  totalVertices: number;
  activeMeshes: number;
  slimeEnergy?: number;
  slimeMass?: number;
}

export class DebugOverlay {
  private metricsElement: HTMLElement | null = null;
  private lastUpdate: number = 0;

  constructor(element?: HTMLElement | null) {
    if (element !== undefined) {
      this.metricsElement = element;
    } else if (typeof document !== 'undefined') {
      this.metricsElement = document.getElementById('hud-metrics');
    }
  }

  public update(metrics: EngineMetrics): void {
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
    // Throttle DOM text updates to 4Hz (every 250ms) to prevent layout thrashing
    if (now - this.lastUpdate < 250) return;
    this.lastUpdate = now;

    if (this.metricsElement) {
      let text = `FPS: ${metrics.fps.toFixed(1)} (${metrics.frameTimeMs.toFixed(1)}ms) | Draw Calls: ${metrics.drawCalls} | Verts: ${metrics.totalVertices.toLocaleString()} | Meshes: ${metrics.activeMeshes}`;
      if (metrics.slimeEnergy !== undefined && metrics.slimeMass !== undefined) {
        text += ` | Gel Energy: ${metrics.slimeEnergy.toFixed(0)}% | Mass: ${metrics.slimeMass.toFixed(1)}kg`;
      }
      this.metricsElement.textContent = text;
    }
  }
}
